export const HELP_PANEL_WIDTH_PX = 510;
export const HELP_DESKTOP_BREAKPOINT_PX = 1300;
export const HELP_DESKTOP_MEDIA = `min-width: ${HELP_DESKTOP_BREAKPOINT_PX + 1}px`;
export const HELP_OVERLAY_MEDIA = `max-width: ${HELP_DESKTOP_BREAKPOINT_PX}px`;
export const PROVIDER_HELP_OVERLAY_Z_INDEX = 20;
export const PROVIDER_HELP_PANEL_Z_INDEX = 30;
export const PROVIDER_MOBILE_MENU_Z_INDEX = 40;
export const PROVIDER_SHELL_HEADER_Z_INDEX = 50;
